(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initTabbedContent(section) {
      if (!section) return;

      const tabButtons = section.querySelectorAll('[data-tab-button]');
      const tabPanels = section.querySelectorAll('[data-tab-panel]');

      function switchTab(button) {
        const tabId = button.dataset.tabTarget;
        let newlyShownPanel = null;

        tabPanels.forEach(panel => {
          const isActive = panel.dataset.tabPanel === tabId;
          const wasActive = !panel.hidden;
          panel.hidden = !isActive;
          panel.classList.toggle('active', isActive);
          if (isActive && !wasActive) {
            newlyShownPanel = panel;
          }
        });

        tabButtons.forEach(btn => {
          const isActive = btn.dataset.tabTarget === tabId;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', isActive);
        });

        // Carousels/sliders inside a tab that was hidden on page load (via the
        // `hidden` attribute) measure 0 width when they first initialize, which
        // is why their nav arrows/dots can end up permanently disabled. Once the
        // panel becomes visible, give the browser a frame to apply layout, then
        // fire a resize event (most carousel libraries recalculate on resize)
        // and a scoped custom event any panel-specific script can listen for to
        // force a re-measure.
        if (newlyShownPanel) {
          requestAnimationFrame(function() {
            window.dispatchEvent(new Event('resize'));
            newlyShownPanel.dispatchEvent(new CustomEvent('tabbed-content:panel-shown', {
              bubbles: true,
              detail: { tabId: tabId }
            }));
          });
        }
      }

      tabButtons.forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          switchTab(this);
        });
      });
    }

    document.querySelectorAll('[data-section-type="tabbed-content"]').forEach(initTabbedContent);

    document.addEventListener('shopify:section:load', function(event) {
      const section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
      if (section && section.dataset.sectionType === 'tabbed-content') {
        initTabbedContent(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
